import { Record, Map } from 'immutable'

export const UserRecordMock = Record({
    firstName: '',
    lastName: '',
    email: '',
    productId: '',
})

export const ModuleAccessRightRecordMock = Record({
    key: '',
    available: false,
    hasRights: false,
    order: 0,
    isCustomLoaded: false,
    custom: Map(),
})

export const LicenseRecordMock = Record({
    licenceName: '',
    licEndDt: null,
    licStrtDt: null,
})

export const AccessRightRecordMock = Record({
    home: new ModuleAccessRightRecordMock({
        key: 'home',
        order: 1,
        available: true,
    }),
    report: new ModuleAccessRightRecordMock({
        key: 'report',
        order: 2,
        available: true,
    }),
    linkages: new ModuleAccessRightRecordMock({
        key: 'linkages',
        order: 5,
        available: true,
    }),
})

const ImporterRecordMock = Record({
    available: false,
})

export const AuthorizationRecordMock = Record({
    isAuthorized: false,
    isLoading: false,
    sessionId: null,
    uniqueId: null,
    user: new UserRecordMock(),
    accessRights: new AccessRightRecordMock(),
    license: new LicenseRecordMock(),
    importer: new ImporterRecordMock(),
})
